import React, { Component } from "react";
import PropTypes from "prop-types";

class DFP extends Component {

    componentDidMount() {
        const { id } = this.props;

        window.googletag.cmd.push(function () {
            window.googletag.display(id);
        });
    }

    render() {
        return <div id={this.props.id} className={this.props.className} />;
    }
}

DFP.propTypes = {
    className: PropTypes.string,
    id: PropTypes.string
};

DFP.defaultProps = {
    className: "",
    id: ""
};

export default DFP;